import React, { Component } from 'react';

class IconWordpress extends Component {
  render() {
    return (

      <div class="icon icon-wordpress">

      <svg viewBox="0 0 54 54" xmlns="http://www.w3.org/2000/svg" xmlnsSerif="http://www.serif.com/"
fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="1.414">
    <g id="icon-wordpress" fill="#00769d">
        <path id="Shape" d="M16.105 16.542h-2.959l8.069 22.778 4.517-12.891-3.502-9.887h-3.123v-2.17h13.828v2.17h-3.238l8.069 22.778 2.9-8.277c3.805-10.605-3.118-13.908-3.118-16.275a4.288 4.288 0 0 1 4.665-4.267 22.359 22.359 0 0 0-15.387-6.107c-7.785 0-14.643 3.963-18.662 9.978h7.941v2.17z"
        />
        <path id="Shape1" serifId="Shape" d="M4.396 26.987c0 8.573 4.825 16.019 11.91 19.781L6.187 18.205a22.282 22.282 0 0 0-1.791 8.782z"
        />
        <path id="Shape2" serifId="Shape" d="M46.653 15.694c.321 1.885.224 4.005-.269 6.133h.09l-.34.967c-.2.699-.453 1.413-.741 2.116l-7.715 21.584c7.07-3.767 11.883-11.205 11.883-19.767 0-4.012-1.058-7.777-2.908-11.033z"
        />
        <path id="Shape3" serifId="Shape" d="M20.095 48.55a22.448 22.448 0 0 0 6.915 1.087c2.302 0 4.523-.347 6.613-.991l-6.558-18.514-6.97 18.418z"
        />
        <path id="Shape4" serifId="Shape" d="M45.746 7.838C40.684 2.784 33.955 0 26.797 0 19.639 0 12.91 2.784 7.849 7.838 2.787 12.892 0 19.612 0 26.761c0 7.148 2.787 13.868 7.849 18.922 5.061 5.054 11.79 7.838 18.948 7.838 7.158 0 13.887-2.784 18.949-7.838 5.061-5.054 7.848-11.775 7.848-18.922 0-7.149-2.787-13.869-7.848-18.923zM26.797 51.633c-13.734 0-24.907-11.158-24.907-24.872 0-13.715 11.173-24.873 24.907-24.873s24.907 11.158 24.907 24.873c0 13.714-11.173 24.872-24.907 24.872z"
        />
    </g>
</svg>

      </div>

    );
  }
}

export default IconWordpress;



// WEBPACK FOOTER //
// ./src/assets/components/icons/iconWordpress.js